import { useState } from "react"
import Input from "../../Input";
import "./style.scss"

const Index = ({ setOpenConfirmationModal, openConfirmationModal, isLoading, onChangeStatus }) => {
    const { data } = openConfirmationModal
    const [trackingNumber, setTrackingNumber] = useState('')
    const [error, setError] = useState('')

    const handleChange = (e) => {
    let value = e.target.value;

    value = value.replace(/\D/g, '');

    if (value.length > 20) {
        value = value.slice(0, 20);
    }

    if (value.length > 0 && value.length < 12) {
        setError('Tracking number must be at least 12 digits.');
    } else {
        setError('');
    }

    setTrackingNumber(value);
};


    return (
        <div className="small-modal-wrapper">
            <div className="confirmation-modal-content">
                <div style={{ position: 'relative', justifyContent: 'center', display: 'flex', width: '100%' }}>
                    <i className='fal fa-times close' style={{ color: '#9a9a9a', position: 'absolute', right: '0px', top: '0px', cursor: 'pointer', zIndex: 9, fontSize: '20px' }} onClick={() => {
                        setOpenConfirmationModal(false)
                    }}></i>
                    <span style={{ width: '44px', height: '44px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', color: 'var(--white)' }}
                        className={data.orderStatus === 1 ? 'progress' : data.orderStatus === 2 ? 'shipped' : data.orderStatus === 3 && 'completed'}
                    >
                        {data.orderStatus === 1
                            ? <i class="fal fa-spinner"></i>
                            : data.orderStatus === 2
                                ? <i class="fal fa-truck"></i>
                                : data.orderStatus === 3 &&
                                <i class="fal fa-check-circle"></i>
                        }
                    </span>
                </div>
                <h2>Are you sure?</h2>
                <p>
                    {data.orderStatus === 1
                        ? 'You are about to change the status of this order to In Progress.'
                        : data.orderStatus === 2
                            ? 'You are about to change the status of this order to Shipped.'
                            : data.orderStatus === 3 &&
                            'You are about to change the status of this order to Completed.'}
                </p>
                {data?.orderStatus === 2 && <div style={{ position: 'relative', width: '100%', display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '10px'}}>
                    <Input placeholder="Enter Tracking Number" value={trackingNumber} onChange={handleChange} />
                    {error && <span style={{ color: 'red', fontSize: '12px' }}>{error}</span>}
                </div>
                }
                <button className={`btn ${data.orderStatus === 1 ? 'progress' : data.orderStatus === 2 ? 'shipped' : data.orderStatus === 3 && 'completed'}`}
                    disabled={(data?.orderStatus === 2 && (!trackingNumber || error)) || isLoading}
                    onClick={() => {
                        if (data.orderStatus === 2 && trackingNumber) {
                            onChangeStatus({ ...data, trackingNumber: [trackingNumber] })
                        } else {
                            onChangeStatus(data)
                        }
                    }}>
                    {data.orderStatus === 1 ? 'Change status to In-Progress' : data.orderStatus === 2 ? 'Change status to Shipped' : data.orderStatus === 3 && 'Change status to Completed'}
                </button>
                <button className='btn transparent' onClick={() => {
                    setOpenConfirmationModal(false)
                }}>Cancel</button>
            </div>
        </div>
    )
}

export default Index